/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_Tea_LotsInputs */

const vi_product_classification_tea_lots = /** @type {(inputs: Product_Classification_Tea_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô chè liên kết`)
};

/**

* @param {Product_Classification_Tea_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_tea_lots = /** @type {((inputs?: Product_Classification_Tea_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_Tea_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_tea_lots(inputs)
});